var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAddChatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99992 1.66659V6.33325H2.44659L1.66659 7.11325V1.66659H8.99992ZM9.66659 0.333252H0.999919C0.633252 0.333252 0.333252 0.633252 0.333252 0.999919V10.3333L2.99992 7.66659H9.66659C10.0333 7.66659 10.3333 7.36659 10.3333 6.99992V0.999919C10.3333 0.633252 10.0333 0.333252 9.66659 0.333252ZM12.9999 2.99992H11.6666V8.99992H2.99992V10.3333C2.99992 10.6999 3.29992 10.9999 3.66659 10.9999H10.9999L13.6666 13.6666V3.66659C13.6666 3.29992 13.3666 2.99992 12.9999 2.99992Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddChatWhite);
export default __webpack_public_path__ + "static/media/icon_add_chat_white.e4601911bb0eb4520b9ace6a95703fc7.svg";
export { ForwardRef as ReactComponent };